import { store } from '../../store';
import { defaultsTo } from '../../utils/utilsGlobal';
import { gql, insertGraphQLFragments } from '../GraphQLClient';
import { fragmentFileBasic, serializeFileBasic } from './serializeFile';


export const fragmentUserBasic = gql`
  fragment fragmentUserBasic on Account {
    __typename
    id
    firstName
    lastName
    ...on Client {
      omnichannelChannelType
    }
  }
`;


export const fragmentUserFull = insertGraphQLFragments(gql`
  fragment fragmentUserFull on Account {
    ...fragmentUserBasic
    ...on Employee {
      role
      email
      isWorking
      hasSchedule
    }
    avatar { ...fragmentFileBasic }
  }
`, { fragmentUserBasic, fragmentFileBasic });


export function serializeUserBasic(data) {
  return defaultsTo(data, {
    id: null,
    firstName: '',
    lastName: '',
    omnichannelChannelType: null,
  });
}


export function serializeUserFull(data) {
  const { id, __typename, role, isWorking, email, avatar } = data || {};
  const { currentOperator } = store.getState();
  const serializedUserBasic = serializeUserBasic(data);

  const isOperator = __typename === 'Employee';
  const isBot = __typename === 'Bot';
  const isClient = __typename === 'Client';
  const isCurrentOperator = data?.isCurrentOperator || id === currentOperator.id;
  const isManager = role === 'admin';
  return {
    ...serializedUserBasic,
    isBot,
    isClient,
    isOperator,
    isCurrentOperator,
    isManager,
    avatar: serializeFileBasic(avatar),
    ...defaultsTo(data, {
      email: '',
      isWorking: false,
      hasSchedule: false,
      switchOffAvailable: false,
    })
  };
}
